// extracted by mini-css-extract-plugin
export default {"fade":"style_fade__GkkPe"};